<app-rules-error-coverage
  [customerIndex]="customerIndex()"
  [coverageIndex]="coverageIndex()"
  [errors]="alertBannerErrors"/>

<form [formGroup]="form">
  @if (sharedPolicyData) {
    <div class="grid-container">
      <!-- First row -->
      <div class="column">
        <div
          cbInput="#sumInsured"
          label="Current Sum Insured"
          styleVariant="white-fill"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [errorState]="errorMessage.length > 0 || hasErrorForCoverage(customerIndex(), coverageIndex(), 'sumInsured')"
          errorMessage="{{ errorMessage }}">
          <input
            #sumInsuredInput
            placeholder="Sum insured is a required field"
            type="text"
            pattern=".*"
            [maxLength]="inputMaxLength"
            [required]="true"
            formControlName="sumInsured"
            (keydown)="allowOnlyNumbers($event)"
            (blur)="onSumInsuredBlur(sumInsuredInput)"
            (focus)="onFocusSelect(sumInsuredInput)"
            (paste)="preventNonNumericPaste($event)"
            (input)="validateNewAgainstOriginal()" />
        </div>
        <!-- Display spinner when isLoading is true -->
        @if (isLoading) {
          <div class="spinner">Please wait... re-calculating...</div>
        }
        @if (coverage().sumInsured!.amount !== coverage().sumInsuredOriginal) {
          <div>
            <p>Original sum insured: ${{ coverage().sumInsuredOriginal! / 100 | number: '1.2-2' }}</p>
          </div>
        }
      </div>
      <div class="column">
        <div
          cbInput="#premium"
          label="Premium"
          styleVariant="gray-fill"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'premium')"
          errorMessage="Error: Premium amount">
          <input
            placeholder="Placeholder"
            type="text"
            pattern=".*"
            maxLength="50"
            [required]="false"
            [disabled]="true"
            [readOnly]="true"
            formControlName="premium" />
        </div>
        @if (coverage().premium!.amount !== coverage().premiumOriginal!) {
          <div>
            <p>Original premium: ${{ coverage().premiumOriginal! / 100 | number: '1.2-2' }}</p>
          </div>
        }
      </div>
      <div class="column">
        <!-- Empty column if needed, or add content -->
      </div>
      <div class="full-width-row">
        <hr />
      </div>
      <!-- Second row -->
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Premium Review Period"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'premiumReviewPeriod')"
          [errorMessage]="
            hasErrorForCoverage(customerIndex(), coverageIndex(), 'premiumReviewPeriod')
              ? 'Error: Premium review period'
              : ''
          ">
          <p-select
            #selectChoice
            [options]="getRefDS('premiumReviewPeriod')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#premiumReviewPeriod"
            formControlName="premiumReviewPeriod"/>
        </div>
      </div>
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Indexation"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'indexation')"
          [errorMessage]="
            hasErrorForCoverage(customerIndex(), coverageIndex(), 'indexation') ? 'Error: Indexation' : ''
          ">
          <p-select
            #selectChoice
            [options]="getRefDS('indexation')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#indexation"
            formControlName="indexation"/>
        </div>
      </div>
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Smoker?"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'smoker')"
          [errorMessage]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'smoker') ? 'Error: Smoker' : ''">
          <p-select
            #selectChoice
            [options]="getRefDS('smoker')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#smoker"
            formControlName="smoker"/>
        </div>
      </div>
      <!-- Forth row -->
      <div class="column">
        <div
          [cbSelectChoice]="selectChoice"
          label="Occupation Class"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default"
          [readonly]="true"
          [errorState]="hasErrorForCoverage(customerIndex(), coverageIndex(), 'occupation.class')"
          [errorMessage]="
            hasErrorForCoverage(customerIndex(), coverageIndex(), 'occupation.class') ? 'Error: occupation class' : ''
          ">
          <p-select
            #selectChoice
            [options]="getRefDS('occupationClass')"
            optionLabel="name"
            optionValue="code"
            placeholder="-"
            inputId="#occupationClass"
            formControlName="occupationClass"/>
        </div>
      </div>
      <div class="column">
        <div
          cbInput="#lifetimeRewardPercent01"
          label="Lifetime Reward"
          styleVariant="gray-fill"
          [errorState]="false"
          colorTheme="default"
          tooltipStyleVariant="stroke"
          tooltipColorTheme="default">
          <input
            placeholder="Placeholder"
            type="text"
            pattern=".*"
            maxLength="50"
            [required]="false"
            [disabled]="true"
            [readOnly]="true"
            formControlName="lifetimeRewardPercent01" />
        </div>
      </div>
      <div class="column">
        <!-- Empty column if needed, or add content -->
      </div>
      <div class="column">
        <div class="toggle-row">
          <div cbToggle="#gio" toggleOnText="" toggleOffText="" [showIcons]="true" [readonly]="true">
            <input type="checkbox" [required]="false" formControlName="gio" />
          </div>
          <span class="label">GIO</span>
        </div>
      </div>
      <div class="column">
        <div class="toggle-row">
          <app-underwriting-terms
            [customerIndex]="customerIndex()"
            [coverageIndex]="coverageIndex()"
            [coverage]="coverage()"/>
        </div>
      </div>
      <div class="column"></div>
    </div>
  }

  <div class="full-width-row">
    <app-remove-cover
      [customerIndex]="customerIndex()"
      [coverageIndex]="coverageIndex()"
      [coverage]="coverage()"/>
  </div>
</form>
